import { useState, useEffect, useRef } from "react";
import api from "../api/client";

export default function IndicatorInput({ item, canEdit}) {
  const [value, setValue] = useState(item.value || "");
  const timeoutRef = useRef(null);

  // ✅ синхронизация при смене отчета / квартала
  useEffect(() => {
    setValue(item.value || "");
  }, [item.id, item.value]);

  const handleChange = (e) => {
    const newValue = e.target.value;

    // ✅ разрешаем только цифры и пустое значение
    if (newValue !== "" && !/^\d+$/.test(newValue)) {
      return;
    }

    setValue(newValue);

    // ❗ очищаем предыдущий таймер (чтобы debounce работал правильно)
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      // ❗ не отправляем пустое значение
      if (newValue === "") return;

      api.patch(`/api/report-value/${item.id}/`, {
        value: newValue,
      }).catch((err) => {
        console.error("Ошибка сохранения:", err);
      });
    }, 500);
  };

  return (
    <div>

      <input
        type="text" // ⚠️ меняем с number → text (иначе будут баги с вводом)
        value={value}
        onChange={handleChange}
        disabled={!canEdit}
      />
    </div>
  );
}
